import http from '../helpers/http';
import Keys from 'stateKeys';
import store from 'utilities/store';
import isStringSet from 'utilities/is/isStringSet';

function storeQRCode(qrCode) {
    store.set(Keys.Auth.State, qrCode);
}

function getQRCode() {
    const qrCode = store.get(Keys.Auth.State);
    return isStringSet(qrCode) ? qrCode : "";
}

function onLoggedIn(qrCode) {
    store.set(Keys.Auth.State, qrCode);
}

function onLoggedOut() {
    store.remove(Keys.Auth.State);
}

export default class AuthRepository {

    getQRCode = getQRCode;

    getLoggedOnCardDetails(cards) {
        const qrCode = getQRCode();
        if (!isStringSet(qrCode)) return null;

        if (!cards) return null;
        return cards[qrCode];
    }

    isLoggedIn() {

        const qrCode = getQRCode();

        const p = new Promise((resolve, reject) => {
            if (!isStringSet(qrCode)) {
                resolve({ isLoggedIn: false });
            }

            http.post('/api/v1/auth/isLoggedIn', { qrCode }).then(response => {
                resolve({ isLoggedIn: response.isLoggedIn || false });
            }).catch(err => reject(err));
        });

        return p;
    }

    initialise(qrCode) {
        onLoggedOut();
        storeQRCode(qrCode);
        return http.post('/api/v1/auth/initialise', { qrCode });
    }

    sendCode(qrCode, sendByEmail, sendBySMS) {
        return http.post('/api/v1/auth/sendcode', { qrCode, sendByEmail, sendBySMS });
    }

    async continue(qrCode, appAuthenticationCode) {
        const clientUserAgent = window.navigator.userAgent;
        const response = await http.post('/api/v1/auth/continue', { qrCode, appAuthenticationCode, clientUserAgent });
        onLoggedIn(qrCode);
        return response;
    }

    async refresh(qrCode, refreshToken) {
        const response = await http.post('/api/v1/auth/refresh', { qrCode, refreshToken });
        onLoggedIn(qrCode);
        return response;
    }

    async signout(qrCode) {
        const response = await http.post('/api/v1/auth/logOut', { qrCode });
        onLoggedOut();
        store.clear();
        return response;
    }
}
